<template>
  <div>
    <Card>
      <p slot="title">油款转账记录</p>

      <!-- Search Form -->
      <Form :model="searchData" :label-width="80" inline>
        <FormItem label="日期">
          <DatePicker
              v-model="searchData.date"
              type="datetimerange"
              placeholder="请选择日期"
              style="width: 200px">
          </DatePicker>
        </FormItem>
        <FormItem label="转出账号">
          <Input
              v-model="searchData.transfer_out"
              placeholder="请输入转出账号"
              style="width: 200px">
          </Input>
        </FormItem>
        <FormItem label="转入账号">
          <Input
              v-model="searchData.transfer_to"
              placeholder="请输入转入账号"
              style="width: 200px">
          </Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="search">查询</Button>
          <Button @click="resetSearch" style="margin-left: 8px">重置</Button>
          <Button type="success" @click="showAddModal" style="margin-left: 8px">新增转账</Button>
        </FormItem>
      </Form>

      <!-- Data Table -->
      <Table
          :columns="tableColumns"
          :data="tableData"
          :loading="loading"
          border>
      </Table>

      <!-- Pagination -->
      <Page
          :total="total"
          :current="currentPage"
          :page-size="pageSize"
          @on-change="changePage"
          style="margin-top: 20px;text-align: right;">
      </Page>
    </Card>

    <!-- Add/Edit Modal -->
    <Modal
        v-model="showModal"
        :title="editMode ? '编辑转账记录' : '新增转账记录'"
        @on-ok="saveTransferLog"
        @on-cancel="cancelModal">

      <Form :model="formData" :label-width="80" ref="transferForm">
        <FormItem label="日期" prop="date" required>
          <DatePicker
              v-model="formData.date"
              type="datetimerange"
              placeholder="请选择日期"
              style="width: 100%">
          </DatePicker>
        </FormItem>
        <FormItem label="转出账号" prop="transfer_out" required>
          <Input
              v-model="formData.transfer_out"
              placeholder="请输入转出账号">
          </Input>
        </FormItem>
        <FormItem label="转入账号" prop="transfer_to" required>
          <Input
              v-model="formData.transfer_to"
              placeholder="请输入转入账号">
          </Input>
        </FormItem>
        <FormItem label="转账金额" prop="money" required>
          <InputNumber
              v-model="formData.money"
              :min="0"
              placeholder="请输入转账金额"
              style="width: 100%">
          </InputNumber>
        </FormItem>
        <FormItem label="服务费" prop="service_fee">
          <InputNumber
              v-model="formData.service_fee"
              :min="0"
              placeholder="请输入服务费"
              style="width: 100%">
          </InputNumber>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input
              v-model="formData.remark"
              type="textarea"
              :rows="4"
              placeholder="请输入备注">
          </Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "transferLists",
  data() {
    return {
      loading: false,
      showModal: false,
      editMode: false,
      editId: null,
      searchData: {
        date: '',
        transfer_out: '',
        transfer_to: ''
      },
      formData: {
        date: '',
        transfer_out: '',
        transfer_to: '',
        money: 0,
        service_fee: 0,
        remark: ''
      },
      tableData: [],
      tableColumns: [
        // {
        //   title: 'ID',
        //   key: 'id',
        //   width: 80,
        //   align: 'center'
        // },
        {
          title: '日期',
          key: 'date',
          width: 220,
          align: 'center'
        },
        {
          title: '转出账户',
          key: 'transfer_out',
          minWidth: 150
        },
        {
          title: '转入账户',
          key: 'transfer_to',
          minWidth: 150
        },
        {
          title: '转账金额',
          key: 'money',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', `¥${params.row.money}`)
          }
        },
        {
          title: '服务费',
          key: 'service_fee',
          width: 100,
          align: 'right',
          render: (h, params) => {
            return h('span', `¥${params.row.service_fee}`)
          }
        },
        // {
        //   title: '创建时间',
        //   key: 'create_time',
        //   width: 160,
        //   align: 'center'
        // },
        {
          title: '备注',
          key: 'remark',
          minWidth: 200
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.editTransferLog(params.row)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: {
                  click: () => {
                    this.deleteTransferLog(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.loadTransferLogs()
  },
  methods: {
    loadTransferLogs() {
      this.loading = true;
      // Get search parameters
      const params = {
        page: this.currentPage,
        page_size: this.pageSize,
        ...this.searchData
      };

      this.$commonFun.postProxy('admin/transfer_log/index', params).then((res) => {
        this.loading = false;
        this.$commonFun.dealApiResult(res, () => {
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
        });
      }).catch(() => {
        this.loading = false;
        this.tableData = [];
        this.total = 0;
      });
    },

    search() {
      this.currentPage = 1;
      this.loadTransferLogs();
    },

    resetSearch() {
      this.searchData = {
        date: '',
        transfer_out: '',
        transfer_to: ''
      };
      this.currentPage = 1;
      this.loadTransferLogs();
    },

    changePage(page) {
      this.currentPage = page;
      this.loadTransferLogs();
    },

    showAddModal() {
      this.editMode = false;
      this.editId = null;
      this.formData = {
        date: '',
        transfer_out: '',
        transfer_to: '',
        money: 0,
        service_fee: 0,
        remark: ''
      };
      this.showModal = true;
    },

    editTransferLog(row) {
      this.editMode = true;
      this.editId = row.id;
      this.formData = { ...row };
      this.showModal = true;
    },

    saveTransferLog() {
      this.$refs.transferForm.validate((valid) => {
        if (valid) {
          const apiEndpoint = this.editMode
              ? 'admin/transfer_log/edit'
              : 'admin/transfer_log/add';

          const requestData = { ...this.formData };
          if (this.editId) {
            requestData.id = this.editId;
          }

          this.$commonFun.postProxy(apiEndpoint, requestData).then((res) => {
            this.$commonFun.dealApiResult(res, () => {
              this.$Message.success(this.editMode ? '更新成功' : '添加成功');
              this.showModal = false;
              this.loadTransferLogs();
            });
          });
        }
      });
    },

    cancelModal() {
      this.showModal = false;
    },

    deleteTransferLog(id) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定要删除这条转账记录吗？',
        onOk: () => {
          this.$commonFun.postProxy('admin/transfer_log/delete', { id: id }).then((res) => {
            this.$Modal.remove();
            this.$commonFun.dealApiResult(res, () => {
              this.$Message.success(res.msg || '删除成功');
              this.loadTransferLogs();
            });
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.ivu-card {
  min-height: calc(100vh - 120px);
}
</style>
